var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhysicianCaptionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2367_86455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3365 16.5131H40.0161C37.4742 16.5131 35.3945 14.4334 35.3945 11.8916C35.3945 9.34967 37.4742 7.27002 40.0161 7.27002H41.3365C43.8783 7.27002 45.958 9.34967 45.958 11.8916C45.958 14.4334 43.8783 16.5131 41.3365 16.5131Z",
    fill: "#F2F3EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1724 16.5131H22.852C20.3101 16.5131 18.2305 14.4334 18.2305 11.8916C18.2305 9.34967 20.3101 7.27002 22.852 7.27002H24.1724C26.7142 7.27002 28.794 9.34967 28.794 11.8916C28.794 14.4334 26.7142 16.5131 24.1724 16.5131Z",
    fill: "#F2F3EE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.95
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.489 72.7949H37.3014C32.8087 72.7949 29.2891 67.9935 29.2891 61.8646V47.3765H35.2311V61.8646C35.2311 65.1379 36.7694 66.853 37.3014 66.853H56.489C57.0208 66.853 58.5586 65.1379 58.5586 61.8646V51.3416H64.5006V61.8646C64.5006 67.9936 60.9816 72.7949 56.489 72.7949Z",
    fill: "#F2F3EE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.5536 12.3511C48.7904 9.69591 44.6998 9.18393 39.8941 9.13312V13.9848C43.5635 14.0254 46.5521 14.3577 48.0636 15.8103C49.0748 16.7819 49.5662 18.4108 49.5662 20.7901C49.5662 25.7916 47.435 32.5529 44.1367 38.0159C40.5706 43.9228 36.2711 47.3103 32.3407 47.3103C23.4582 47.3103 15.1149 30.7657 15.1149 20.7901C15.1149 18.4108 15.6063 16.7819 16.6175 15.8103C18.1546 14.3333 21.2171 14.0155 24.9714 13.9837V9.13086C20.0861 9.17055 15.9262 9.66201 13.1276 12.3511C11.1175 14.2825 10.1406 17.0429 10.1406 20.7901C10.1406 31.8107 19.2955 52.1648 32.3407 52.1648C45.3857 52.1648 54.5405 31.8107 54.5405 20.7901C54.5405 17.0429 53.5636 14.2825 51.5536 12.3511Z",
    fill: "#F2F3EE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.6395 56.6232C57.0889 56.6232 53.3867 52.9211 53.3867 48.3705C53.3867 43.8198 57.0889 40.1177 61.6395 40.1177C66.1901 40.1177 69.8922 43.8198 69.8922 48.3705C69.8922 52.9212 66.1901 56.6232 61.6395 56.6232ZM61.6395 46.0597C60.3655 46.0597 59.3287 47.0964 59.3287 48.3705C59.3287 49.6445 60.3655 50.6812 61.6395 50.6812C62.9135 50.6812 63.9503 49.6445 63.9503 48.3705C63.9503 47.0964 62.9135 46.0597 61.6395 46.0597Z",
    fill: "#F2F3EE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2367_86455"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.75,
    height: 65.5248,
    fill: "white",
    transform: "translate(10.1406 7.27002)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysicianCaptionWhite);
export default __webpack_public_path__ + "static/media/physician-caption-white.c20d5f472ebfff84b4d9454d5852215d.svg";
export { ForwardRef as ReactComponent };